import React from 'react';
import AppContext, { serverToClientStore } from '../context';

const AppContextProvider = ({ children }) => {
  return (
    <AppContext.Provider value={serverToClientStore()}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
